export const getDimensions = (
  targetElement: HTMLDivElement
): { height: number; offsetTop: number; offsetBottom: number } => {
  const { height } = targetElement.getBoundingClientRect();
  const offsetTop = targetElement.offsetTop;
  const offsetBottom = offsetTop + height;

  return {
    height,
    offsetTop,
    offsetBottom
  };
};

export const scrollTo = (
  targetElement: HTMLDivElement,
  offsetElement?: HTMLDivElement
): void => {
  const { height: offsetHeight } = offsetElement
    ? getDimensions(offsetElement)
    : { height: 0 };

  const offsetHeightDelta = offsetHeight > 0 ? offsetHeight - 1 : 0;
  const elementPosition = targetElement.offsetTop;
  const offsetPosition = elementPosition - offsetHeightDelta;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth"
  });
};
